import React, { useEffect, useState } from 'react'
import { DataGrid as MUIDataGrid, DataGridProps, GridRowId, GridCellEditCommitParams } from '@mui/x-data-grid'
import moment, { isDate } from 'moment'

type Props = DataGridProps & {
  toAssign: boolean
  setRoutineSelected: any
  rows: []
}

export const DataGrid = ({ toAssign, setRoutineSelected, rows, ...data }: Props) => {
  const [pageSize, setPageSize] = useState<number>(20)
  const [rowsResult, setRowsResult] = useState<any[]>(rows)
  const [selectionModel, setSelectionModel] = useState<GridRowId[]>([])

  useEffect(() => {
    setRowsResult(rows)
  }, [rows])

  const selectRow = (routineRows: any[], rowSelected: any[]) => {
    setRoutineSelected()
    routineRows.forEach(function (routine) {
      if (rowSelected.includes(routine.id)) {
        setRoutineSelected(routine)
      }
    })
  }

  const handleCellEditCommit = async ({ id, field, value }: GridCellEditCommitParams) => {
    const index = rowsResult.findIndex(row => row.id === id)
    rowsResult[index][field] = value
    if (isDate(value) && (field === 'startedAt' || field === 'dueDateAt')) {
      rowsResult[index][field] = moment(value).format('DD/MM/YYYY')
    } else if (field !== 'startedAt' && field !== 'dueDateAt') {
      setRowsResult(rowsResult)
    }
  }

  useEffect(() => {
    setRowsResult(rows)
  }, [rows])

  return (
    <MUIDataGrid
      {...data}
      style={{
        borderTopWidth: 0.5,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderRadius: 0
      }}
      rows={rowsResult}
      autoHeight={true}
      rowHeight={65}
      checkboxSelection={toAssign}
      disableSelectionOnClick
      rowsPerPageOptions={[20, 40, 80]}
      pagination
      pageSize={pageSize}
      onCellEditCommit={handleCellEditCommit}
      selectionModel={selectionModel}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      onSelectionModelChange={(selection) => {
        if (selection.length <= 1) {
          setSelectionModel(selection)
          selectRow(rowsResult, selection)
        } else if (selectionModel.length > 0) {
          const selectionSet = new Set(selectionModel)
          const result = selection.filter((s) => !selectionSet.has(s))
          setSelectionModel(result)
          selectRow(rowsResult, result)
        }
      }}
    />
  )
}
